export const formatNumber = (value, isScore = false) => {
  if (value === 0 || value === '0') return '0';
  if (value === null || value === undefined || value === '') return '-';
  if (value === Infinity || value === -Infinity) { return 'Inf'; }
  const num = parseFloat(value);
  if (isNaN(num)) return '-';
  if (isScore) {
    return Math.round(num).toLocaleString();
  }
  return num.toLocaleString();
};

export const formatDifference = (value, asPercent = false, asMultiple = false) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  if (value === Infinity || value === -Infinity) {
    return 'Inf';
  }
  
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (asPercent) {
    if (numericValue === 0) {
      return '0%';
    }
    if (Math.abs(numericValue) < 0.1) {
      return `${numericValue >= 0 ? '+' : '-'}<0.1%`;
    }
    const roundedValue = Math.round(numericValue * 10) / 10;
    return `${numericValue >= 0 ? '+' : ''}${formatNumber(roundedValue)}%`;
  }

  if (asMultiple) {
    if (numericValue === Infinity || numericValue === -Infinity) {
      return 'Inf';
    }
    if (numericValue === 0) {
      return '0x';
    }
    if (numericValue === 1) {
      return '1x';
    }
    return `${formatNumber(numericValue)}x`;
  }

  return numericValue > 0 ? `+${formatNumber(numericValue)}` : formatNumber(numericValue);
};

export const formatRank = (rank) => {
  if (!rank || rank === '') return '-';
  
  if (typeof rank === 'number') {
    return rank.toLocaleString();
  }
  
  const match = rank.match(/\d+/);
  if (match) {
    const numericPart = parseInt(match[0], 10);
    if (!isNaN(numericPart)) {
      const prefix = rank.substring(0, rank.indexOf(numericPart));
      return `${prefix}${numericPart.toLocaleString()}`;
    }
  }
  
  return rank;
};

export const formatPercentile = (value) => {
  if (!value || value === '') return '-';
  const num = parseFloat(value);
  if (isNaN(num)) return '-';
  
  if (num > 0 && num < 1) {
    return '1st';
  }
  
  const rounded = Math.round(num);
  return `${rounded}${getOrdinalSuffix(rounded)}`;
};

export const getOrdinalSuffix = (num) => {
  const number = Math.round(num);
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;
  
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return 'th';
  }
  
  switch (lastDigit) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

export const formatDateRanges = (dateRange) => {
  const yearRegex = /^\d{4}$/;
  
  if (yearRegex.test(dateRange)) {
    const currentYear = parseInt(dateRange);
    const prevYear = currentYear - 1;
    
    return {
      currentRange: `1/1/${currentYear} - 12/31/${currentYear}`,
      prevRange: `1/1/${prevYear} - 12/31/${prevYear}`
    };
  }
};

export const formatRate = (rate) => {
  if (rate === null || rate === undefined) return '-';
  return formatNumber(rate, true);
};